import { render, staticRenderFns } from "./RoundedTwitterIcon.vue?vue&type=template&id=f7f40212"
import script from "./RoundedTwitterIcon.vue?vue&type=script&lang=js"
export * from "./RoundedTwitterIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports